import { fetchQuery } from "react-relay"
import { graphql } from "relay-runtime"
import { fetchDeProgressNoteBetterDocResultQuery } from "@/modules/patients/detail/better-doc/de/services/__generated__/fetchDeProgressNoteBetterDocResultQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const deProgressNoteBetterDocResultQuery = graphql`
  query fetchDeProgressNoteBetterDocResultQuery($progressNoteId: ID!) {
    de_progressNoteById(id: $progressNoteId) {
      id
      ...deProgressNoteBetterDocResultFragment
    }
  }
`

export const fetchDeProgressNoteBetterDocResult = (progressNoteId: string) =>
  fetchQuery<fetchDeProgressNoteBetterDocResultQuery>(
    RelayEnvironment,
    deProgressNoteBetterDocResultQuery,
    { progressNoteId },
    { fetchPolicy: "network-only" },
  ).toPromise()
